module.exports = __webpack_public_path__ + "img/4_76.39f86e86.png";